// extracted by mini-css-extract-plugin
export default {"cell":"Feature_cell__eS22T","active":"Feature_active__ZRmOR","inactive":"Feature_inactive__LZbvh"};